import banner from '@/api/banners'

export default {
  methods: {
    getShowBannerForCategoryFlag: async function (category) {
      try {
        const result = await banner.getShowBannerForCategoryFlag(category)
        if (result.data.code === 200) {
          return result.data.result.category
        }
      } catch (error) {
        console.error(error)
      }
    },
    getCategorySetsForCategoryPage: async function (partner = 'make', categoryId = 0, categorySlug) {
      try {
        const params = {
          categoryID: categoryId,
          categorySlug: categorySlug
        }
        const result = await banner.getCategorySetsForCategoryPage(partner, params)
        if (result.data.code === 200) {
          return result.data.result.banners
        }
      } catch (error) {
        console.error(error)
      }
    },
    getBannerSetForNonCategoryPage: async function (bannerSetName) {
      try {
        const result = await banner.getBannerSetForNonCategoryPage(bannerSetName)
        if (result.data.code === 200) {
          return result.data.result.banners
        }
      } catch (error) {
        console.error(error)
      }
    },
    getBannerButtonsForCategoryPage: async function (partner = 'make', categoryId = 0) {
      try {
        const params = {
          categoryID: categoryId
        }
        const result = await banner.getBannerButtonsForCategoryPage(partner, params)
        if (result.data.code === 200) {
          return result.data.result.bannerButtons
        }
      } catch (error) {
        console.error(error)
      }
    },
    getBannerButtonsForNonCategoryPage: async function (bannerSetName) {
      try {
        const result = await banner.getBannerButtonsForNonCategoryPage(bannerSetName)
        if (result.data.code === 200) {
          return result.data.result.banners
        }
      } catch (error) {
        console.error(error)
      }
    },
    getCategorySets: function (partnerId, categoryId) {
      banner.getCategorySets(partnerId, categoryId).then((response) => {
        this.banners = response.data.result.banners
      }, (error) => {
        console.error(error)
      })
    }
  }
}
